import { FC } from "react";
import Email from "../../../components/forms/Email";
import FormData from "../../../components/forms/FormData";
import FormError from "../../../components/forms/FormError";
import FormLabel from "../../../components/forms/FormLabel";
import FormTable from "../../../components/forms/FormTable";
import FormTr from "../../../components/forms/FormTr";
import Input from "../../../components/forms/Input";
import { ValidationErrors } from "../../../services/types";
import { formatBoolean } from "../../../services/utils";
import * as Fields from "./Fields";
import { GroupForm } from "./types";

interface NewEditTableProps {
  state: GroupForm;
  setState: React.Dispatch<React.SetStateAction<GroupForm | undefined>>;
  errors: ValidationErrors;
}

const NewEditTable: FC<NewEditTableProps> = ({ state, setState, errors }: NewEditTableProps) => {
  return (
    <FormTable>
      <FormTr>
        <FormLabel required>{Fields.name.title}</FormLabel>
        <FormData>
          <Input
            value={state.name}
            onChange={(value) =>
              setState({
                ...state,
                name: value,
              })
            }
          />
          <FormError error={errors[Fields.name.fieldName]} />
        </FormData>
      </FormTr>
      <FormTr>
        <FormLabel>{Fields.email.title}</FormLabel>
        <FormData>
          <Email
            value={state.email}
            onChange={(value) =>
              setState({
                ...state,
                email: value,
              })
            }
          />
          <FormError error={errors[Fields.email.fieldName]} />
        </FormData>
      </FormTr>
      <FormTr>
        <FormLabel>{Fields.description.title}</FormLabel>
        <FormData>
          <Input
            value={state.description}
            onChange={(value) =>
              setState({
                ...state,
                description: value,
              })
            }
          />
        </FormData>
      </FormTr>
      <FormTr>
        <FormLabel>{Fields.isActiveDirectoryGroup.title}</FormLabel>
        <FormData disp>{formatBoolean(state.isActiveDirectoryGroup)}</FormData>
      </FormTr>
    </FormTable>
  );
};

export default NewEditTable;
